import { Inputs } from "./inputs";

var __extends =
  (this && this.__extends) ||
  (function () {
    var extendStatics = function (d, b) {
      extendStatics =
        Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array &&
          function (d, b) {
            d.__proto__ = b;
          }) ||
        function (d, b) {
          for (var p in b)
            if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
      return extendStatics(d, b);
    };
    return function (d, b) {
      if (typeof b !== "function" && b !== null)
        throw new TypeError(
          "Class extends value " + String(b) + " is not a constructor or null"
        );
      extendStatics(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype =
        b === null
          ? Object.create(b)
          : ((__.prototype = b.prototype), new __());
    };
  })();
export function uuidGenerate() {
  return new Date().getTime().toString();
}
export var Model = /** @class */ (function () {
  function Model() {}
  Model.prototype.getProps = function () {
    var $this = this;
    var $keys = Object.keys($this);
    var $collection = new Array();
    $keys.forEach(function ($item, $index) {
      $collection.push({
        key: $item,
        type: $this[$item],
      });
    });
    return $collection;
  };
  return Model;
})();
export var User = /** @class */ (function (_super) {
  __extends(User, _super);
  function User() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.full_name = "";
    _this.username = "";
    _this.dob = "";
    _this.mobile = "";
    _this.phone = "";
    _this.email = "";
    _this.is_blocked = false;
    _this.is_locked = false;
    _this.password_must_change = false;
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.governorate = "Governorate";
    _this.ngo = "Ngo";
    _this.parent = "User";
    _this.children = "User";
    _this.ngoRoles = "NgoRole";
    _this.inputs = Inputs.USER_SCHEMA;
    return _this;
  }
  return User;
})(Model);
export var Ngo = /** @class */ (function (_super) {
  __extends(Ngo, _super);
  function Ngo() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name_ar = "";
    _this.name_en = "";
    _this.acronym = "";
    _this.logo = "";
    _this.about = "";
    _this.services_description = "";
    _this.decision_no = "";
    _this.decision_date = "";
    _this.has_public_benefit = false;
    _this.has_organizational_structure = false;
    _this.has_emp_internal_system = false;
    _this.has_women_private_system = false;
    _this.has_volunteering_system = false;
    _this.is_all_syria_covered = false;
    _this.status_date = "";
    _this.dissolution_decision_no = "";
    _this.dissolution_date = "";
    _this.objectives = "";
    _this.neighborhood = "";
    _this.address = "";
    _this.longitude = "";
    _this.latitude = "";
    _this.qr_active = "";
    _this.completed_by_ngo_at = "";
    _this.completed_by_directorate_at = "";
    _this.completed_by_ministry_at = "";
    _this.created_at = "";
    _this.updated_at = "";
    _this.deleted_at = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.status = "NgoStatus";
    _this.legalForm = "LegalForm";
    _this.parent = "Ngo";
    _this.serviceCentres = "ServiceCentre";
    _this.bankAccounts = "BankAccount";
    _this.branches = "Branch";
    _this.users = "User";
    _this.contacts = "ContactInformation";
    _this.ngoServices = "NgoService";
    _this.classifications = "NgoClassification";
    _this.governorates = "Governorate";
    _this.plans = "Plan";
    _this.categories = "AgeCategory";
    _this.incentives = "Incentive";
    _this.annualBudgets = "AnnualBudget";
    _this.projects = "Project";
    _this.alliedNgos = "Ngo";
    _this.alliances = "Ngo";
    _this.assist = "Assist";
    _this.paymentMethods = "PaymentMethod";
    _this.directors = "Director";
    _this.children = "Ngo";
    _this.completedByNgo = "User";
    _this.completedByDirectorate = "MinistryUser";
    _this.completedByMinistry = "MinistryUser";
    _this.organizationalInformation = "OrganizationalInformation";
    _this.weights = "Weight";
    _this.directorBoards = "DirectorBoard";
    _this.generalAuthorityMembers = "GeneralAuthorityMember";
    _this.inputs = Inputs.NGO_SCHEMA;
    return _this;
  }
  return Ngo;
})(Model);
export var NgoClassification = /** @class */ (function (_super) {
  __extends(NgoClassification, _super);
  function NgoClassification() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name_ar = "";
    _this.name_en = "";
    _this.code = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.parent = "NgoClassification";
    _this.children = "NgoClassification";
    _this.services = "Service";
    _this.ngoServices = "NgoService";
    _this.ngos = "Ngo";
    _this.inputs = Inputs.NGO_CLASSIFICATION_SCHEMA;
    return _this;
  }
  return NgoClassification;
})(Model);
export var Branch = /** @class */ (function (_super) {
  __extends(Branch, _super);
  function Branch() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name = "";
    _this.decision_date = "";
    _this.services = "";
    _this.address = "";
    _this.headquarters_type = "";
    _this.management_committee = "";
    _this.longitude = "";
    _this.latitude = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.ngo = "Ngo";
    _this.subDistrict = "Area";
    _this.branchType = "BranchType";
    _this.realEstate = "RealEstate";
    _this.branchServices = "NgoService";
    _this.users = "User";
    _this.contacts = "ContactInformation";
    _this.governorate = "Governorate";
    _this.employees = "Employee";
    _this.inputs = Inputs.BRANCH_SCHEMA;
    return _this;
  }
  return Branch;
})(Model);
export var Employee = /** @class */ (function (_super) {
  __extends(Employee, _super);
  function Employee() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.code = "";
    _this.insurance_number = "";
    _this.first_name = "";
    _this.last_name = "";
    _this.father_name = "";
    _this.mother_name = "";
    _this.birthday = "";
    _this.id_number = "";
    _this.position = "";
    _this.contact_number = "";
    _this.member_status = false;
    _this.gander = false;
    _this.address = "";
    _this.work = "";
    _this.qualifications = "";
    _this.employment_date = "";
    _this.resignation_date = "";
    _this.is_holds_disability_card = false;
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.employeeRole = "EmployeeRole";
    _this.branch = "Branch";
    _this.employmentType = "EmploymentType";
    _this.qualification = "Qualification";
    _this.program = "Program";
    _this.inputs = Inputs.EMPLOYEE_SCHEMA;
    return _this;
  }
  return Employee;
})(Model);
export var EmployeeRole = /** @class */ (function (_super) {
  __extends(EmployeeRole, _super);
  function EmployeeRole() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name = "";
    _this.slug = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.inputs = Inputs.EMPLOYEE_ROLE_SCHEMA;
    return _this;
  }
  return EmployeeRole;
})(Model);
export var EmploymentType = /** @class */ (function (_super) {
  __extends(EmploymentType, _super);
  function EmploymentType() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name = "";
    _this.slug = "";
    _this.inputs = Inputs.EMPLOYMENT_TYPE_SCHEMA;
    return _this;
  }
  return EmploymentType;
})(Model);
export var BranchType = /** @class */ (function (_super) {
  __extends(BranchType, _super);
  function BranchType() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name_ar = "";
    _this.name_en = "";
    _this.code = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.branches = "Branch";
    _this.inputs = Inputs.BRANCH_TYPE_SCHEMA;
    return _this;
  }
  return BranchType;
})(Model);
export var ContactInformation = /** @class */ (function (_super) {
  __extends(ContactInformation, _super);
  function ContactInformation() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.type = "Type";
    _this.value = "";
    _this.entity = null;
    _this.inputs = Inputs.CONTACT_SCHEMA;
    return _this;
  }
  return ContactInformation;
})(Model);
export var Type = /** @class */ (function (_super) {
  __extends(Type, _super);
  function Type() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name_ar = "";
    _this.name_en = "";
    _this.slug = "";
    _this.icon = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.contacts = "ContactInformation";
    _this.inputs = Inputs.TYPE_SCHEMA;
    return _this;
  }
  return Type;
})(Model);
export var AgeCategory = /** @class */ (function (_super) {
  __extends(AgeCategory, _super);
  function AgeCategory() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name_ar = "";
    _this.name_en = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.services = "Service";
    _this.governorates = "Governorate";
    _this.ngos = "Ngo";
    _this.campaigns = "Campaign";
    _this.inputs = Inputs.AGE_CATEGORY_SCHEMA;
    return _this;
  }
  return AgeCategory;
})(Model);
export var Governorate = /** @class */ (function (_super) {
  __extends(Governorate, _super);
  function Governorate() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name_ar = "";
    _this.name_en = "";
    _this.phone_prefix = "";
    _this.is_governorate = false;
    _this.areas = "Area";
    _this.services = "Service";
    _this.categories = "AgeCategory";
    _this.ngos = "Ngo";
    _this.opportunities = "Opportunity";
    _this.news = "News";
    _this.campaigns = "Campaign";
    _this.machines = "Machine";
    _this.realEstates = "RealEstate";
    _this.users = "User";
    _this.estNgos = "EstablishmentNgo";
    _this.branches = "Branch";
    _this.assistObjects = "AssistObject";
    _this.faqs = "Faq";
    _this.projectGovernorates = "ProjectGovernorate";
    _this.inputs = Inputs.GOVERNORATE_SCHEMA;
    return _this;
  }
  return Governorate;
})(Model);
export var Machine = /** @class */ (function (_super) {
  __extends(Machine, _super);
  function Machine() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.model = "";
    _this.plate_number = "";
    _this.serial_number = "";
    _this.structure_no = "";
    _this.fuel_type = "";
    _this.passengers_number = 0;
    _this.year = 0;
    _this.tax = false;
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.machineType = "MachineType";
    _this.governorate = "Governorate";
    _this.possessiveForm = "PossessiveForm";
    _this.ngo = "Ngo";
    _this.inputs = Inputs.MACHINE_SCHEMA;
    return _this;
  }
  return Machine;
})(Model);
export var MachineType = /** @class */ (function (_super) {
  __extends(MachineType, _super);
  function MachineType() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name_ar = "";
    _this.name_en = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.ngo = "Ngo";
    _this.machines = "Machine";
    _this.inputs = Inputs.MACHINE_TYPE_SCHEMA;
    return _this;
  }
  return MachineType;
})(Model);
export var PossessiveForm = /** @class */ (function (_super) {
  __extends(PossessiveForm, _super);
  function PossessiveForm() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name_ar = "";
    _this.name_en = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.realEstates = "RealEstate";
    _this.machines = "Machine";
    _this.inputs = Inputs.POSSESSIVE_FORM_SCHEMA;
    return _this;
  }
  return PossessiveForm;
})(Model);
export var RealEstate = /** @class */ (function (_super) {
  __extends(RealEstate, _super);
  function RealEstate() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.number = "";
    _this.region = "";
    _this.is_operating = false;
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.estateType = "EstateType";
    _this.governorate = "Governorate";
    _this.possessiveForm = "PossessiveForm";
    _this.ngo = "Ngo";
    _this.inputs = Inputs.REAL_ESTATES_SCHEMA;
    return _this;
  }
  return RealEstate;
})(Model);
export var EstateType = /** @class */ (function (_super) {
  __extends(EstateType, _super);
  function EstateType() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name_ar = "";
    _this.name_ar = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.realEstates = "RealEstate";
    _this.inputs = Inputs.ESTATE_TYPE_SCHEMA;
    return _this;
  }
  return EstateType;
})(Model);
export var News = /** @class */ (function (_super) {
  __extends(News, _super);
  function News() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.title_ar = "";
    _this.title_en = "";
    _this.description_ar = "";
    _this.description_en = "";
    _this.accomplished_at_date = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.governorate = "Governorate";
    _this.ngo = "Ngo";
    _this.inputs = Inputs.NEWS_SCHEMA;
    return _this;
  }
  return News;
})(Model);
export var Campaign = /** @class */ (function (_super) {
  __extends(Campaign, _super);
  function Campaign() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name_ar = "";
    _this.name_en = "";
    _this.description_ar = "";
    _this.description_en = "";
    _this.campaign_amount = 0;
    _this.featured = false;
    _this.count = 0;
    _this.confirmed = false;
    _this.campaign_type = false;
    _this.start_date = "";
    _this.end_date = "";
    _this.is_active = false;
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.ngo = "Ngo";
    _this.ageCategories = "AgeCategory";
    _this.governorate = "Governorate";
    _this.donors = "Donor";
    _this.inputs = Inputs.CAMPAIGN_SCHEMA;
    return _this;
  }
  return Campaign;
})(Model);
export var Donor = /** @class */ (function (_super) {
  __extends(Donor, _super);
  function Donor() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name = "";
    _this.is_famous = false;
    _this.donated_amount = 0;
    _this.donated_type = false;
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.campaign = "Campaign";
    _this.inputs = Inputs.DONOR_SCHEMA;
    return _this;
  }
  return Donor;
})(Model);
export var Opportunity = /** @class */ (function (_super) {
  __extends(Opportunity, _super);
  function Opportunity() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name = "";
    _this.type = "";
    _this.vacancies_number = 0;
    _this.code = "";
    _this.opportunity_objectives_ar = "";
    _this.opportunity_objectives_en = "";
    _this.employment_type_ar = "";
    _this.employment_type_en = "";
    _this.skill_ar = "";
    _this.skill_en = "";
    _this.certificate_ar = "";
    _this.certificate_en = "";
    _this.experience_ar = "";
    _this.experience_en = "";
    _this.starting_date = "";
    _this.closing_date = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.ngo = "Ngo";
    _this.positionType = "PositionType";
    _this.governorate = "Governorate";
    _this.inputs = Inputs.OPPORTUNITY_SCHEMA;
    return _this;
  }
  return Opportunity;
})(Model);
export var PositionType = /** @class */ (function (_super) {
  __extends(PositionType, _super);
  function PositionType() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name_ar = "";
    _this.name_en = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.inputs = Inputs.POSITION_TYPE_SCHEMA;
    return _this;
  }
  return PositionType;
})(Model);
export var NgoStatus = /** @class */ (function (_super) {
  __extends(NgoStatus, _super);
  function NgoStatus() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name_ar = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.ngos = "Ngo";
    _this.inputs = Inputs.NGO_STATUS_SCHEMA;
    return _this;
  }
  return NgoStatus;
})(Model);
export var LegalForm = /** @class */ (function (_super) {
  __extends(LegalForm, _super);
  function LegalForm() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name_ar = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.ngos = "Ngo";
    _this.inputs = Inputs.LEGAL_FORM_SCHEMA;
    return _this;
  }
  return LegalForm;
})(Model);
export var ServiceCentre = /** @class */ (function (_super) {
  __extends(ServiceCentre, _super);
  function ServiceCentre() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name = "";
    _this.clearance_decision_no = "";
    _this.switchboard = "";
    _this.address = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.ngo = "Ngo";
    _this.ngo = "RealEstate";
    _this.area = "Area";
    _this.serviceCentreType = "ServiceCenterType";
    _this.clearanceAuthority = "ClearanceAuthority";
    _this.inputs = Inputs.SERVICE_CENTRE_SCHEMA;
    return _this;
  }
  return ServiceCentre;
})(Model);
export var ServiceCenterType = /** @class */ (function (_super) {
  __extends(ServiceCenterType, _super);
  function ServiceCenterType() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.ServiceCentres = "ServiceCenterType";
    _this.inputs = Inputs.SERVICE_CENTRE_TYPE_SCHEMA;
    return _this;
  }
  return ServiceCenterType;
})(Model);
export var ClearanceAuthority = /** @class */ (function (_super) {
  __extends(ClearanceAuthority, _super);
  function ClearanceAuthority() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.serviceCentres = "ServiceCentre";
    _this.inputs = Inputs.CLEARANCE_AUTHORITY_SCHEMA;
    return _this;
  }
  return ClearanceAuthority;
})(Model);
export var Area = /** @class */ (function (_super) {
  __extends(Area, _super);
  function Area() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name_ar = "";
    _this.name_en = "";
    _this.alias_name = "";
    _this.code = "";
    _this.level = "";
    _this.longitude = "";
    _this.latitude = "";
    _this.governorate = "Governorate";
    _this.parent = "Area";
    _this.children = "Area";
    _this.inputs = Inputs.AREA_SCHEMA;
    return _this;
  }
  return Area;
})(Model);
export var Service = /** @class */ (function (_super) {
  __extends(Service, _super);
  function Service() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name_ar = "";
    _this.name_en = "";
    _this.description = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.ngoServices = "NgoService";
    _this.classification = "NgoClassification";
    _this.ageCategories = "AgeCategory";
    _this.governorates = "Governorate";
    _this.urgentActivities = "Activity";
    _this.inputs = Inputs.SERVICE_SCHEMA;
    return _this;
  }
  return Service;
})(Model);
export var NgoService = /** @class */ (function (_super) {
  __extends(NgoService, _super);
  function NgoService() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.description = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.service = "Service";
    _this.serviceType = "ServiceType";
    _this.status = "ServiceStatus";
    _this.serviceFrequency = "ServiceFrequency";
    _this.inputs = Inputs.NGO_SERVICE_SCHEMA;
    return _this;
  }
  return NgoService;
})(Model);
export var ServiceFrequency = /** @class */ (function (_super) {
  __extends(ServiceFrequency, _super);
  function ServiceFrequency() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name_ar = "";
    _this.name_en = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.ngoServices = "NgoService";
    _this.inputs = Inputs.SERVICE_FREQUENCY_SCHEMA;
    return _this;
  }
  return ServiceFrequency;
})(Model);
export var ServiceType = /** @class */ (function (_super) {
  __extends(ServiceType, _super);
  function ServiceType() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name_ar = "";
    _this.name_en = "";
    _this.description = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.ngoServices = "NgoService";
    _this.inputs = Inputs.SERVICE_TYPE_SCHEMA;
    return _this;
  }
  return ServiceType;
})(Model);
export var ServiceStatus = /** @class */ (function (_super) {
  __extends(ServiceStatus, _super);
  function ServiceStatus() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name_ar = "";
    _this.color = "";
    _this.slug = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.inputs = Inputs.SERVICE_STATUS_SCHEMA;
    return _this;
  }
  return ServiceStatus;
})(Model);
export var BankAccount = /** @class */ (function (_super) {
  __extends(BankAccount, _super);
  function BankAccount() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.branch_name = "";
    _this.account_no = "";
    _this.is_available = false;
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.bank = "Bank";
    _this.ngo = "Ngo";
    _this.accountManagers = "AccountManager";
    _this.inputs = Inputs.BANK_ACCOUNT_SCHEMA;
    return _this;
  }
  return BankAccount;
})(Model);
export var Bank = /** @class */ (function (_super) {
  __extends(Bank, _super);
  function Bank() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name_ar = "";
    _this.name_en = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.bankAccounts = "BankAccount";
    _this.inputs = Inputs.BANK_SCHEMA;
    return _this;
  }
  return Bank;
})(Model);
export var AccountManager = /** @class */ (function (_super) {
  __extends(AccountManager, _super);
  function AccountManager() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.full_name = "";
    _this.id_number = "";
    _this.assign_date = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.bankAccount = "BankAccount";
    _this.ngo = "Ngo";
    _this.inputs = Inputs.ACCOUNT_MANAGER_SCHEMA;
    return _this;
  }
  return AccountManager;
})(Model);
export var Program = /** @class */ (function (_super) {
  __extends(Program, _super);
  function Program() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name = "";
    _this.objectives = "";
    _this.start_date = "";
    _this.end_date = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.activities = "Activity";
    _this.categories = "AgeCategory";
    _this.services = "Service";
    _this.ngo = "Ngo";
    _this.plans = "Plan";
    _this.inputs = Inputs.PROGRAM_SCHEMA;
    return _this;
  }
  return Program;
})(Model);
export var Activity = /** @class */ (function (_super) {
  __extends(Activity, _super);
  function Activity() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name = "";
    _this.objectives = "";
    _this.activity_type = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.ngo = "Ngo";
    _this.program = "Program";
    _this.categories = "AgeCategory";
    _this.services = "NgoService";
    _this.plans = "Plan";
    _this.urgentServices = "Service";
    _this.inputs = Inputs.ACTIVITY_SCHEMA;
    return _this;
  }
  return Activity;
})(Model);
export var Plan = /** @class */ (function (_super) {
  __extends(Plan, _super);
  function Plan() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.year = "";
    _this.status = "";
    _this.code = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.ngo = "Ngo";
    _this.programs = "Program";
    _this.activities = "Activity";
    _this.inputs = Inputs.PLAN_SCHEMA;
    return _this;
  }
  return Plan;
})(Model);
export var AnnualBudget = /** @class */ (function (_super) {
  __extends(AnnualBudget, _super);
  function AnnualBudget() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.year = "";
    _this.final_budget = 0;
    _this.next_year_budget = 0;
    _this.ngo = "Ngo";
    _this.inputs = Inputs.ANNUAL_BUDGET_SCHEMA;
    return _this;
  }
  return AnnualBudget;
})(Model);
export var AssistCategory = /** @class */ (function (_super) {
  __extends(AssistCategory, _super);
  function AssistCategory() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.assistObjects = "AssistObject";
    _this.inputs = Inputs.ASSIST_CATEGORY_SCHEMA;
    return _this;
  }
  return AssistCategory;
})(Model);
export var AssistObject = /** @class */ (function (_super) {
  __extends(AssistObject, _super);
  function AssistObject() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.title = "";
    _this.description = "";
    _this.count = 0;
    _this.demanded = false;
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.assistCategory = "AssistCategory";
    _this.governorate = "Governorate";
    _this.inputs = Inputs.ASSIST_OBJECT_SCHEMA;
    return _this;
  }
  return AssistObject;
})(Model);
export var BoardType = /** @class */ (function (_super) {
  __extends(BoardType, _super);
  function BoardType() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name = "";
    _this.slug = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.organizationalInformation = "OrganizationalInformation";
    _this.inputs = Inputs.BOARD_TYPE_SCHEMA;
    return _this;
  }
  return BoardType;
})(Model);
export var Director = /** @class */ (function (_super) {
  __extends(Director, _super);
  function Director() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name = "";
    _this.dob = "";
    _this.phone_number = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.ngo = "Ngo";
    _this.jobTitle = "JobTitle";
    _this.qualification = "Qualification";
    _this.directorBoard = "DirectorBoard";
    _this.inputs = Inputs.DIRECTOR_SCHEMA;
    return _this;
  }
  return Director;
})(Model);
export var DirectorBoard = /** @class */ (function (_super) {
  __extends(DirectorBoard, _super);
  function DirectorBoard() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.board_year = "";
    _this.board_end_year = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.ngo = "Ngo";
    _this.directors = "Director";
    _this.directorType = "DirectorType";
    _this.inputs = Inputs.DIRECTOR_BOARD_SCHEMA;
    return _this;
  }
  return DirectorBoard;
})(Model);
export var DirectorType = /** @class */ (function (_super) {
  __extends(DirectorType, _super);
  function DirectorType() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name = "";
    _this.slug = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.directorBoards = "DirectorBoard";
    _this.inputs = Inputs.DIRECTOR_TYPE_SCHEMA;
    return _this;
  }
  return DirectorType;
})(Model);
export var Division = /** @class */ (function (_super) {
  __extends(Division, _super);
  function Division() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name = "";
    _this.projectDivisions = "ProjectDivision";
    _this.inputs = Inputs.DIVISION_SCHEMA;
    return _this;
  }
  return Division;
})(Model);
export var EstablishmentAccount = /** @class */ (function (_super) {
  __extends(EstablishmentAccount, _super);
  function EstablishmentAccount() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.first_name = "";
    _this.last_name = "";
    _this.father_name = "";
    _this.username = "";
    _this.phone_number = "";
    _this.id_number = "";
    _this.email = "";
    _this.is_active = false;
    _this.validated = false;
    _this.estNgo = "EstablishmentNgo";
    _this.history = "RequestHistory";
    _this.inputs = Inputs.ESTABLISHMENT_ACCOUNT_SCHEMA;
    return _this;
  }
  return EstablishmentAccount;
})(Model);
export var EstablishmentMember = /** @class */ (function (_super) {
  __extends(EstablishmentMember, _super);
  function EstablishmentMember() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.full_name = "";
    _this.id_number = "";
    _this.address = "";
    _this.qualifications = "";
    _this.jobs = "";
    _this.phone_number = "";
    _this.is_active = false;
    _this.validated = false;
    _this.estNgo = "EstablishmentNgo";
    _this.history = "RequestHistory";
    _this.inputs = Inputs.ESTABLISHMENT_MEMBER_SCHEMA;
    return _this;
  }
  return EstablishmentMember;
})(Model);
export var EstablishmentNgo = /** @class */ (function (_super) {
  __extends(EstablishmentNgo, _super);
  function EstablishmentNgo() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.ngo_name = "";
    _this.fst_alt_ngo_name = "";
    _this.sec_alt_ngo_name = "";
    _this.accepted_ngo_name = "";
    _this.status = "";
    _this.headquarters_address = "";
    _this.real_estate_number = "";
    _this.objectives = "";
    _this.occupation_legal_form = "";
    _this.legal_form_type = "";
    _this.is_active = false;
    _this.validated = false;
    _this.estAccount = "EstablishmentAccount";
    _this.estMembers = "EstablishmentMember";
    _this.governorates = "Governorate";
    _this.hqGovernorate = "Governorate";
    _this.classifications = "NgoClassification";
    _this.history = "RequestHistory";
    _this.inputs = Inputs.ESTABLISHMENT_NGO_SCHEMA;
    return _this;
  }
  return EstablishmentNgo;
})(Model);
export var Faq = /** @class */ (function (_super) {
  __extends(Faq, _super);
  function Faq() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.question_ar = "";
    _this.answer_ar = "";
    _this.question_en = "";
    _this.answer_en = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.faqCategory = "FaqCategory";
    _this.inputs = Inputs.FAQ_SCHEMA;
    return _this;
  }
  return Faq;
})(Model);
export var FaqCategory = /** @class */ (function (_super) {
  __extends(FaqCategory, _super);
  function FaqCategory() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.type = "";
    _this.name_ar = "";
    _this.name_en = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.faqs = "Faq";
    _this.inputs = Inputs.FAQ_CATEGORY_SCHEMA;
    return _this;
  }
  return FaqCategory;
})(Model);
export var GeneralAuthorityMember = /** @class */ (function (_super) {
  __extends(GeneralAuthorityMember, _super);
  function GeneralAuthorityMember() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.full_name = "";
    _this.id_number = "";
    _this.phone_number = "";
    _this.gender = false;
    _this.dob = "";
    _this.affiliation_date = "";
    _this.active = false;
    _this.can_vote = false;
    _this.ngo = "Ngo";
    _this.inputs = Inputs.GENERAL_AUTHORITY_MEMBER_SCHEMA;
    return _this;
  }
  return GeneralAuthorityMember;
})(Model);
export var Incentive = /** @class */ (function (_super) {
  __extends(Incentive, _super);
  function Incentive() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name = "";
    _this.type = "";
    _this.decision_no = "";
    _this.decision_date = "";
    _this.read_at = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.incentiveType = "IncentiveType";
    _this.ngo = "Ngo";
    _this.inputs = Inputs.INCENTIVE_SCHEMA;
    return _this;
  }
  return Incentive;
})(Model);
export var IncentiveType = /** @class */ (function (_super) {
  __extends(IncentiveType, _super);
  function IncentiveType() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name_ar = "";
    _this.name_en = "";
    _this.incentives = "Incentive";
    _this.inputs = Inputs.INCENTIVE_TYPE_SCHEMA;
    return _this;
  }
  return IncentiveType;
})(Model);
export var JobTitle = /** @class */ (function (_super) {
  __extends(JobTitle, _super);
  function JobTitle() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name = "";
    _this.slug = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.directors = "Director";
    _this.inputs = Inputs.JOB_TITLE_SCHEMA;
    return _this;
  }
  return JobTitle;
})(Model);
export var MeetingMinute = /** @class */ (function (_super) {
  __extends(MeetingMinute, _super);
  function MeetingMinute() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.title = "";
    _this.meeting_date = "";
    _this.attendance_names = "";
    _this.note = "";
    _this.seen_at = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.seenBy = "MinistryUser";
    _this.ngo = "Ngo";
    _this.meetingType = "MeetingType";
    _this.inputs = Inputs.MEETING_MINUTE_SCHEMA;
    return _this;
  }
  return MeetingMinute;
})(Model);
export var MeetingType = /** @class */ (function (_super) {
  __extends(MeetingType, _super);
  function MeetingType() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name_ar = "";
    _this.name_en = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.meetingMinutes = "MeetingMinute";
    _this.inputs = Inputs.MEETING_TYPE_SCHEMA;
    return _this;
  }
  return MeetingType;
})(Model);
export var MinistryPermission = /** @class */ (function (_super) {
  __extends(MinistryPermission, _super);
  function MinistryPermission() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name = "";
    _this.slug = "";
    _this.type = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.ministryRoles = "MinistryRole";
    _this.inputs = Inputs.MINISTRY_PERMISSION_SCHEMA;
    return _this;
  }
  return MinistryPermission;
})(Model);
export var MinistryRole = /** @class */ (function (_super) {
  __extends(MinistryRole, _super);
  function MinistryRole() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name = "";
    _this.slug = "";
    _this.selected = false;
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.ministryPermissions = "MinistryPermission";
    _this.ministryUsers = "MinistryUser";
    _this.inputs = Inputs.MINISTRY_ROLE_SCHEMA;
    return _this;
  }
  return MinistryRole;
})(Model);
export var MinistryUser = /** @class */ (function (_super) {
  __extends(MinistryUser, _super);
  function MinistryUser() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.full_name = "";
    _this.username = "";
    _this.dob = "";
    _this.mobile = "";
    _this.phone = "";
    _this.email = "";
    _this.is_blocked = false;
    _this.is_locked = false;
    _this.ministry_user_type = false;
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.governorate = "Governorate";
    _this.meetingMinutes = "MeetingMinute";
    _this.ministryRoles = "MinistryRole";
    _this.inputs = Inputs.MINISTRY_USER_SCHEMA;
    return _this;
  }
  return MinistryUser;
})(Model);
export var Assist = /** @class */ (function (_super) {
  __extends(Assist, _super);
  function Assist() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.ngo = "Ngo";
    _this.assistObjects = "AssistObject";
    _this.inputs = Inputs.ASSIST_SCHEMA;
    return _this;
  }
  return Assist;
})(Model);
export var NgoPermission = /** @class */ (function (_super) {
  __extends(NgoPermission, _super);
  function NgoPermission() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name = "";
    _this.slug = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.ngoRoles = "NgoRole";
    _this.inputs = Inputs.NGO_PERMISSION_SCHEMA;
    return _this;
  }
  return NgoPermission;
})(Model);
export var NgoRole = /** @class */ (function (_super) {
  __extends(NgoRole, _super);
  function NgoRole() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name = "";
    _this.slug = "";
    _this.selected = false;
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.ngoPermissions = "NgoPermission";
    _this.users = "User";
    _this.inputs = Inputs.NGO_ROLE_SCHEMA;
    return _this;
  }
  return NgoRole;
})(Model);
export var OrganizationalInformation = /** @class */ (function (_super) {
  __extends(OrganizationalInformation, _super);
  function OrganizationalInformation() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.board_members_count = 0;
    _this.board_election_date = "";
    _this.term_of_office = 0;
    _this.public_authority_total_count = 0;
    _this.authorised_to_vote_count = 0;
    _this.public_authority_last_meeting = 0;
    _this.members_type = false;
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.boardType = "BoardType";
    _this.ngo = "Ngo";
    _this.inputs = Inputs.ORGANIZATIONAL_INFORMATION_SCHEMA;
    return _this;
  }
  return OrganizationalInformation;
})(Model);
export var PaymentMethod = /** @class */ (function (_super) {
  __extends(PaymentMethod, _super);
  function PaymentMethod() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.phone_number = "";
    _this.username = "";
    _this.active = false;
    _this.terminal_id = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.paymentMethodType = "PaymentMethodType";
    _this.ngo = "Ngo";
    _this.inputs = Inputs.PAYMENT_METHOD_SCHEMA;
    return _this;
  }
  return PaymentMethod;
})(Model);
export var PaymentMethodType = /** @class */ (function (_super) {
  __extends(PaymentMethodType, _super);
  function PaymentMethodType() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name = "";
    _this.paymentMethods = "PaymentMethod";
    _this.inputs = Inputs.PAYMENT_METHOD_TYPE_SCHEMA;
    return _this;
  }
  return PaymentMethodType;
})(Model);
export var Project = /** @class */ (function (_super) {
  __extends(Project, _super);
  function Project() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.code = "";
    _this.name = "";
    _this.cooperation_relation = "";
    _this.ben_number = 0;
    _this.working_employees_number = 0;
    _this.working_volunteers_number = 0;
    _this.total_employees_number = 0;
    _this.total_volunteers_number = 0;
    _this.perma_vacancies_number = 0;
    _this.tempo_vacancies_number = 0;
    _this.total_vacancies_number = 0;
    _this.duration_by_months = 0;
    _this.register_date = "";
    _this.expected_budget = 0;
    _this.ngo = "Ngo";
    _this.UNAgent = "UNAgent";
    _this.activities = "Activity";
    _this.divisions = "Division";
    _this.financialInfo = "ProjectFinancialInformation";
    _this.governorates = "Governorate";
    _this.objectives = "ProjectObjective";
    _this.inputs = Inputs.PROJECT_SCHEMA;
    return _this;
  }
  return Project;
})(Model);
export var ProjectActivity = /** @class */ (function (_super) {
  __extends(ProjectActivity, _super);
  function ProjectActivity() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name = "";
    _this.expected_budget = 0;
    _this.budget_percentage = 0;
    _this.output_type = "";
    _this.expected_output = "";
    _this.project = "Project";
    _this.objective = "ProjectObjective";
    _this.inputs = Inputs.PROJECT_ACTIVITY_SCHEMA;
    return _this;
  }
  return ProjectActivity;
})(Model);
export var ProjectDivision = /** @class */ (function (_super) {
  __extends(ProjectDivision, _super);
  function ProjectDivision() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.expected_budget = 0;
    _this.ben_number = 0;
    _this.ben_women_percentage = 0;
    _this.ben_disabled_percentage = 0;
    _this.division = "Division";
    _this.category = "AgeCategory";
    _this.project = "Project";
    _this.inputs = Inputs.PROJECT_DIVISION_SCHEMA;
    return _this;
  }
  return ProjectDivision;
})(Model);
export var ProjectFinancialInformation = /** @class */ (function (_super) {
  __extends(ProjectFinancialInformation, _super);
  function ProjectFinancialInformation() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.expected_budget_usd = 0;
    _this.expected_budget_sp = 0;
    _this.total_budget = 0;
    _this.administrative_expenses_percentage = 0;
    _this.un_agent_contribution_value = 0;
    _this.local_ngo_contribution_value = 0;
    _this.bank_name = "";
    _this.bank_governorate = "";
    _this.bank_address = "";
    _this.project = "Project";
    _this.bankAccount = "BankAccount";
    _this.accountManager = "AccountManager";
    _this.inputs = Inputs.PROJECT_FINANCIAL_INFORMATION_SCHEMA;
    return _this;
  }
  return ProjectFinancialInformation;
})(Model);
export var ProjectGovernorate = /** @class */ (function (_super) {
  __extends(ProjectGovernorate, _super);
  function ProjectGovernorate() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.expected_budget = 0;
    _this.ben_number = 0;
    _this.project = "Project";
    _this.governorate = "Governorate";
    _this.area = "Area";
    _this.inputs = Inputs.PROJECT_GOVERNORATE_SCHEMA;
    return _this;
  }
  return ProjectGovernorate;
})(Model);
export var ProjectObjective = /** @class */ (function (_super) {
  __extends(ProjectObjective, _super);
  function ProjectObjective() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name = "";
    _this.project = "Project";
    _this.inputs = Inputs.PROJECT_OBJECTIVE_SCHEMA;
    return _this;
  }
  return ProjectObjective;
})(Model);
export var Qualification = /** @class */ (function (_super) {
  __extends(Qualification, _super);
  function Qualification() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.title = "";
    _this.createdBy = "User";
    _this.updatedBy = "User";
    _this.deletedBy = "User";
    _this.employees = "Employee";
    _this.directors = "Director";
    _this.inputs = Inputs.QUALIFICATION_SCHEMA;
    return _this;
  }
  return Qualification;
})(Model);
export var RequestHistory = /** @class */ (function (_super) {
  __extends(RequestHistory, _super);
  function RequestHistory() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.reported = null;
    _this.action_type = "";
    _this.reporter = "User";
    _this.inputs = Inputs.REQUEST_HISTORY_SCHEMA;
    return _this;
  }
  return RequestHistory;
})(Model);
export var UNAgent = /** @class */ (function (_super) {
  __extends(UNAgent, _super);
  function UNAgent() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name = "";
    _this.projects = "Project";
    _this.inputs = Inputs.UN_AGENT_SCHEMA;
    return _this;
  }
  return UNAgent;
})(Model);
export var Weight = /** @class */ (function (_super) {
  __extends(Weight, _super);
  function Weight() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.name = "";
    _this.token = "";
    _this.link = "";
    _this.mark = 0;
    _this.completion_value = 0;
    _this.ngos = "Ngo";
    _this.inputs = Inputs.WEIGHT_SCHEMA;
    return _this;
  }
  return Weight;
})(Model);
export var Event = /** @class */ (function (_super) {
  __extends(Event, _super);
  function Event() {
    var _this = _super.call(this) || this;
    _this.id = 0;
    _this.title_ar = "";
    _this.title_en = "";
    _this.from_event_date = "";
    _this.to_event_date = "";
    _this.from_event_duration = "";
    _this.to_event_duration = "";
    _this.from_time = "";
    _this.to_time = "";
    _this.description_ar = "";
    _this.description_en = "";
    _this.location = "";
    _this.link = "";
    _this.is_full_day = "";
    _this.invitation_type = "";
    _this.ngo = "Ngo";
    _this.inputs = Inputs.EVENTS_SCHEMA
    console.log("Inputs.EVENTS_SCHEMA" , Inputs.EVENTS_SCHEMA)
    return _this;
  }
  return Event;
})(Model);
